import React, {useState} from 'react';
import './Footer.css';



  
const Footer = () => {
return (

            
            <div class="foot-section">
                <p>
                    Copyright &copy; 2020 by 홈쿠킹레시피 All rights reserved.
                </p>
            </div>
            
)
}

export default Footer;